module.exports = __webpack_public_path__ + "img/thank5.2aede83a.gif";